<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.qualitySpecification.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link>
          </li>-->
          <li class="breadcrumb-item">
            <router-link to="/prd/qualitySpecification">
              <span>{{$t('tlt.qualitySpecification')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualitySpecification/edit">
              <span>{{$t('tlt.qualitySpecification.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('qualitySpecification')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button
            class="btn btn-primary"
            type="button"
            v-on:click="MMFSave('qualitySpecification')"
          >
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySpecification.code')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="code"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('code') }"
                  v-model="code"
                  type="text"
                />
                <span v-show="errors.has('code')" class="lbl-obg">{{ errors.first('code') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySpecification.name')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="name"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('name') }"
                  v-model="name"
                  type="text"
                />
                <span v-show="errors.has('name')" class="lbl-obg">{{ errors.first('name') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySpecification.upLimit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="upLimit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('upLimit') }"
                  v-model="upLimit"
                  type="text"
                />
                <span v-show="errors.has('upLimit')" class="lbl-obg">{{ errors.first('upLimit') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySpecification.lowLimit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="lowLimit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('lowLimit') }"
                  v-model="lowLimit"
                  type="text"
                />
                <span v-show="errors.has('lowLimit')" class="lbl-obg">{{ errors.first('lowLimit') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySpecification.unit')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="unit"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('unit') }"
                  v-model="unit"
                  type="text"
                />
                <span v-show="errors.has('unit')" class="lbl-obg">{{ errors.first('unit') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>



<script>
import { createHelpers } from "vuex-map-fields";
import { mapActions, mapState } from "vuex";
import { fields } from "@/model/prd/qualityMgt/QualitySpecification";

const { mapFields } = createHelpers({
  getterType: "qualitySpecification/getField",
  mutationType: "qualitySpecification/updateField"
});
export default {
  data() {
    return {};
  },
  computed: {
    ...mapFields(fields),
    ...mapState({})
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"])
  },
  components: {}
};
</script>